export default function ScrollToTop() {
  window.scrollTo({ top: 0 });
}